const UI_CONSTANTS = {
  partners: {
    alipp: {
      logo: {
        src: "https://anniblob.blob.core.windows.net/partnerlogos/alippi.png",
        link: "https://www.alippi.de",
      },
      contactDetails: {
        tel: "030 577 12186",
        mail: "thomas@anni.care",
      },
    },
    spoerer: {
      logo: {
        src: "https://anniblob.blob.core.windows.net/partnerlogos/spoerer.png",
        link: "https://www.spoerer.de",
      },
      contactDetails: {
        tel: "08 41 4911-0",
        mail: "info@spoerer.de",
      },
    },
    streifeneder: {
      logo: {
        src: "https://anniblob.blob.core.windows.net/partnerlogos/streifeneder.png",
        link: "https://www.streifeneder.de",
      },
    },
    incort: {
      logo: {
        src: "https://anniblob.blob.core.windows.net/partnerlogos/INCORT.jpg",
        link: "https://www.incort.de",
      },
      contactDetails: {
        tel: "041 41 411 90",
        mail: "info@incort.de",
      },
    },
    stolle: {
      logo: {
        src: "https://anniblob.blob.core.windows.net/partnerlogos/STOLLE.jpg",
        link: "https://www.stolle-ot.de",
      },
      contactDetails: {
        tel: "040 645 960",
        mail: "info@stolle-ot.de",
      },
    },
  },
  anni: {
    url: "https://www.anni.care",
  },
  meta: {
    beratung: {
      title: "Hilfsmitel-Beratung - anni.care",
      metaTags: [
        {
          name: "description",
          content:
            "In der Beratung können Sie einfach die richtigen Hilfsmittel wie Rollatoren oder Pflegebetten für Ihre individuelle Situation finden.",
          viewport: "width=device-width,initial-scale=0.9",
        },
      ],
    },
    pflegegrad: {
      title: "Pflegegrad-Antrag - anni.care",
      metaTags: [
        {
          name: "description",
          content:
            "Mit unserem digitalen Pflegegrad-Antrag können Sie einfach einen Pflegegrad beantragen, um Leistungen aus der Pflegekasse beziehen zu können.",
          viewport: "width=device-width,initial-scale=0.9",
        },
      ],
    },
    searchEngine: {
      title: {
        companyTitle: "anni.care",
        mergeCompanyTitle: function (titlePrefix) {
          return `${titlePrefix} - ${this.companyTitle}`;
        },
        hilfsmittelFinderTitle: "Hilfsmittel-Finder",
        getHilfsmittelFinderFullTitle: function () {
          return `${this.hilfsmittelFinderTitle} - ${this.companyTitle}`;
        },
      },
      meta: {
        default: {
          name: "description",
          content:
            "Mit unserem Hilfsmittel-Finder können Sie einfach die richtigen Hilfsmittel für Ihre individuelle Situation finden.",
        },
      },
    },
    storeFinder: {
      title: "Passende Sanitätshäuser in Ihrer Nähe finden",
      metaTags: [
        {
          name: "description",
          content:
            "Sie sind auf der Suche nach einem Sanitätshaus in Ihrer Nähe? Wir helfen Ihnen dabei, den passenden Gesundheitspartner für Ihre individuelle Situation zu finden.",
        },
      ],
    },
    partnerHome: {
      title: "Partner Cockpit - anni.care",
      metaTags: [
        {
          name: "description",
          content:
            "Im Partner Cockpit von anni.care sehen Sie Kunden-Anfragen und können Ihren Unternehmensauftritt verwalten.",
        },
      ],
    },
  },
  requestErrTitle: "Ups. Hier ist leider etwas schiefgelaufen.",
  requestErrMsg:
    "Leider konnte der Termin nicht gebucht werden. Das tut uns sehr leid! Bitte rufen Sie uns kurz an, damit wir Ihren Termin vereinbaren können.",
  requestNumber: "Telefon: 030 5200 1258",
  wrongEmail: "Bitte geben Sie eine gültige E-Mail Adresse ein!",
  wrongTelephone: "Bitte geben Sie eine gültige Telefonnummer ein!",
  wrongName: "Bitte geben Sie einen gültigen Namen ein!",
  wrongStreet: "Bitte geben Sie einen gültigen Straße und Hausnummer ein!",
  wrongCity: "Bitte geben Sie einen gültigen Ort ein!",
  wrongZip: "Bitte geben Sie einen gültigen Postleitzahl ein!",
  noProductsNoAddressMsg:
    "Bitte wählen Sie zuerst Hilfsmittel aus und geben Ihren Ort ein.",
  noProducts: "Bitte wählen Sie zuerst Hilfsmittel aus.",
  noProduct: "Bitte wählen Sie Hilfsmittel aus.",
  noAddressMsg: "Bitte geben Sie zuerst Ihren Ort ein.",
  headerBookingText: {
    telephone: {
      default:
        "Wählen Sie zuerst ein passendes Datum für Ihre telefonische Beratung.",
      dateSelected:
        "Wählen Sie nun eine passende Uhrzeit für Ihre telefonische Beratung.",
      timeslotSelected:
        "Reservieren Sie jetzt den gewünschten Termin für Ihre telefonische Beratung.",
    },
    video: {
      default: "Wählen Sie zuerst ein passendes Datum für Ihre Video-Beratung.",
      dateSelected:
        "Wählen Sie nun eine passende Uhrzeit für Ihre Video-Beratung.",
      timeslotSelected:
        "Reservieren Sie jetzt den gewünschten Termin für Ihre Video-Beratung.",
    },
    instore: {
      default:
        "Wählen Sie zuerst ein passendes Datum für Ihre Beratung in der Filiale.",
      dateSelected:
        "Wählen Sie nun eine passende Uhrzeit für Ihre Beratung in der Filiale.",
      timeslotSelected:
        "Reservieren Sie jetzt den gewünschten Termin für Ihre Beratung in der Filiale.",
    },
  },
  seoOnlyOneProduct: "SEA Page only supports 1 productID parameter",
  getStoresErrMsg:
    "Leider konnten wir keine passenden Anbieter zu Ihrer Such-Anfrage finden.",
  fileSizeOverMsg: "Die ausgewählte Dateigröße beträgt mehr als 10 MB.",
  fileExtErrorMsg: "Die Dateierweiterung ist ungültig.",
  disabledDatePop: "Keine Termine verfügbar",
  pricePopData: {
    condition_1: {
      title: "Was kostet ein Kassen-Rollator?",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Bei einem Kassen-Rollator haben Sie keine freie Auswahl des Rollators. Deshalb richtet sich der genaue Preis danach, welches Modell die Versicherung Ihnen über einen Anbieter zur Verfügung stellt. Sie zahlen bei einem Kassenrollator allerdings `,
            },
            {
              type: "bold",
              desc: `maximal 10 Euro`,
            },
            {
              type: "normal",
              desc: ` gesetzliche Zuzahlung.`,
            },
          ],
        },
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: "Mit unserem Service können Sie risikofrei bestellen. Ein qualifizierter Anbieter liefert Ihnen das gewählte Modell zum Wunschtermin. ",
            },
            {
              type: "bold",
              desc: "Sie bezahlen erst nach Lieferung und profitieren von 14 Tagen Rückgaberecht.",
            },
          ],
        },
      ],
    },
    condition_2: {
      title: "Was kostet dieser Rollator?",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Für Rollatoren auf Rezept gibt es Verträge zwischen Krankenversicherungen und Anbietern. Weil diese Verträge sehr unterschiedlich sind, richten sich die genauen Kosten nach Ihrer Krankenversicherung und dem jeweiligen Anbieter.`,
            },
          ],
        },
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: "Mit unserem Service können Sie deswegen risikofrei bestellen. Ein qualifizierter Anbieter liefert Ihnen das gewählte Modell zum Wunschtermin. ",
            },
            {
              type: "bold",
              desc: "Sie bezahlen erst nach Lieferung und profitieren von 14 Tagen Rückgaberecht.",
            },
          ],
        },
      ],
    },
    condition_3: {
      title: "Was kostet dieser Rollator?",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Es gibt unterschiedliche Modelle innerhalb dieser Kategorie. Den genauen Preis erfahren Sie auf Basis des Modells, die Ihnen zum Testen geliefert wird.`,
            },
          ],
        },
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: "Mit unserem Service können Sie deswegen risikofrei bestellen. Ein qualifizierter Anbieter liefert Ihnen das gewählte Modell zum Wunschtermin. ",
            },
            {
              type: "bold",
              desc: "Sie bezahlen erst nach Lieferung und profitieren von 14 Tagen Rückgaberecht.",
            },
          ],
        },
      ],
    },
    condition_5: {
      title: "Rezept einlösen bei diesem Rollator",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Wenn Sie sich beim Kauf eines Rollators mit Rezept für ein höherwertiges Modell als den Kassen-Rollator entscheiden, dann übernimmt die Krankenversicherung in der Regel die Grundkosten für den Rollator - etwa in der Höhe der Kosten für einen Kassen-Rollator. `,
            },
          ],
        },
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: "Mit unserem Service können Sie deswegen risikofrei bestellen. Ein qualifizierter Anbieter liefert Ihnen das gewählte Modell zum Wunschtermin. ",
            },
            {
              type: "bold",
              desc: "Sie bezahlen erst nach Lieferung und profitieren von 14 Tagen Rückgaberecht.",
            },
          ],
        },
      ],
    },
    condition_6: {
      title: "Rabatt gegen Rezeptvorlage",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Für diesen Premium-Rollator übernimmt die Krankenversicherung keine Kosten. `,
            },
            {
              type: "bold",
              desc: `Wenn Sie bei der Lieferung ein gültiges Rezept für einen Rollator übergeben, dann erhalten Sie trotzdem den “Rezeptwert” als Rabatt (60€).`,
            },
          ],
        },
      ],
    },
  },
  productPopData: {
    condition_1: {
      title: "Neu oder gebraucht",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Bei `,
            },
            {
              type: "bold",
              desc: `Standard-Rollatoren auf Rezept`,
            },
            {
              type: "normal",
              desc: ` muss neben der gesetzlich vorgeschriebenen Zuzahlung (maximal 10 Euro) kein Eigenanteil bezahlt werden. Diese “Kassenrollatoren” sind dafür aber nicht immer auf dem neuesten Standard und häufig gebraucht.`,
            },
          ],
        },
      ],
    },
    condition_2: {
      title: "Kassen-Rollator",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Für Rollatoren auf Rezept gibt es Verträge zwischen Krankenversicherungen und Anbietern. `,
            },
            {
              type: "bold",
              desc: `Bei einem Kassen-Rollator haben Sie keine freie Auswahl des Rollators.`,
            },
          ],
        },
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Das konkrete Modell, das Ihre Versicherung Ihnen über einen Anbieter zur Verfügung stellt, kann daher variieren. Die dargestellten Rollatoren sind beispielhaft dargestellt. Bitte beachten Sie, dass wir kein spezielles Modell garantieren können.`,
            },
          ],
        },
      ],
    },
    condition_3: {
      title: "Kategorie garantiert",
      content: [
        {
          type: "text",
          subtitle: null,
          body: [
            {
              type: "normal",
              desc: `Die dargestellten Rollatoren sind beispielhaft dargestellt. Die aktuelle Marke und das aktuelle Modell, das Sie bei der Lieferung erhalten, können variieren. Bitte beachten Sie, dass wir kein spezielles Modell garantieren können.`,
            },
          ],
        },
      ],
    },
  },
  serviceEmail: "partner@anni.care",
};

export default UI_CONSTANTS;
